const areas = [
  'Snellville', 'Lawrenceville', 'Duluth', 'Grayson', 'Loganville',
  'Dacula', 'Buford', 'Suwanee', 'Norcross', 'Lilburn',
  'Stone Mountain', 'Lithonia', 'Conyers', 'Covington', 'Monroe',
  'Winder', 'Auburn', 'Braselton', 'Alpharetta', 'Dunwoody',
  'Decatur', 'Tucker', 'Clarkston', 'Atlanta', 'Cumming',
];

export default function ServiceAreas() {
  return (
    <section id="service-areas" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        <div className="text-center mb-16">
          <p className="text-amber-600 text-[11px] font-bold tracking-[0.25em] uppercase mb-3">Local Coverage</p>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mb-4">
            Serving Snellville &amp; Metro Atlanta
          </h2>
          <div className="w-16 h-px bg-amber-500 mx-auto mb-5"></div>
          <p className="text-stone-500 text-lg max-w-xl mx-auto">
            Based in Snellville, GA — our certified technicians serve homeowners and businesses across Gwinnett, DeKalb, Rockdale, Newton, and surrounding counties.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">

          {/* Map */}
          <div className="rounded-2xl overflow-hidden border border-stone-100 min-h-[460px]">
            <iframe
              title="Carpet & Flooring Transformers — 1943 Main St E, Snellville, GA 30078"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3314.5!2d-83.99455108077922!3d33.856476799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5b980054fed57%3A0x804c6a7ac1d1fe82!2sCarpet%20%26%20Flooring%20Transformers!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '460px', display: 'block' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Cities + CTA */}
          <div className="flex flex-col justify-between gap-8">
            <div>
              <p className="text-stone-700 font-bold text-sm uppercase tracking-widest mb-5">Cities We Serve</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2.5">
                {areas.map((city) => (
                  <div key={city} className="flex items-center gap-2 text-sm text-stone-600">
                    <div className="w-3 h-3 flex items-center justify-center text-amber-500 flex-shrink-0">
                      <i className="ri-map-pin-fill text-xs"></i>
                    </div>
                    <span>{city}, GA</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-stone-50 border border-stone-100 rounded-2xl p-7">
              <div className="flex items-start gap-4 mb-5">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-2-fill text-amber-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-stone-900 font-bold text-base">1943 Main St E</p>
                  <p className="text-stone-500 text-sm">Snellville, GA 30078</p>
                </div>
              </div>
              <p className="text-stone-500 text-sm mb-5">
                Don&apos;t see your city listed? We may still service your area. Give us a call to confirm coverage.
              </p>
              <a
                href="tel:7702361255"
                className="inline-flex items-center gap-2 bg-stone-900 hover:bg-amber-700 text-white font-bold text-sm px-7 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill"></i>
                </div>
                Call 770.236.1255
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
